import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import {FormattedHTMLMessage} from 'react-intl';
import axios from 'axios';
var moment = require('moment');

import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js'
import Section from './Section.js'
import RenderField from './RenderField';
import CustomSpinner from './CustomSpinner';
import CustomAlert from '../components/CustomAlert.js';
import Whatsapp from './WhatsappButton.js';
import TempLink from './TempLink';

class SmsForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            code: '',
            lastSentDate: null,
        };

        this.getSmsCode = this.getSmsCode.bind(this);
    }

    componentDidMount() {

        const ROOT_URL = process.env.API_URL;
        var config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
            }
        };

        axios.get(`${ROOT_URL}/sms/send_code`, config)
            .then(res => {
                const code = res.data.code;
                this.setState({
                    code: code,
                    lastSentDate: res.data.sms_code_timestamp,
                });
            }
        );
    }

    getSmsCode() {
        const ROOT_URL = process.env.API_URL;
        var config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken'),
            },
        };

        return axios.get(`${ROOT_URL}/sms/send_code?required=true`, config);
    }

    render() {
        const { handleSubmit, submitting, error } = this.props;
        const { lastSentDate } = this.state;

        const nextDateToSent = lastSentDate ?  moment(lastSentDate).add(120, 'seconds') : null;
        const remaningSeconds = lastSentDate ? nextDateToSent.diff(moment(), 'seconds') : null;
        let TempLinkComponent;

        if(remaningSeconds){
            TempLinkComponent = (<TempLink actionText={'Reenviar sms'} onTime={this.getSmsCode} seconds={remaningSeconds}>¿Todavía no llega tu código? </TempLink>)
        }

        return (
            <Section className="intro_form">
                <div className="row">
                    <div className="pd-content-left col-md-5 col-lg-5 text-center">
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                        <FormattedHTMLMessage id="app.step_sms" description="Sms info"/>
                        {TempLinkComponent}
                        <Whatsapp phone={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                                  text={this.context.intl.formatMessage({
                                      id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                                  value={this.context.intl.formatMessage({
                                      id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                                  gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>

                        <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                    </div>
                    <div className="pd-content-right short-content col-sm-12 col-md-7 col-lg-7">
                        <form onSubmit={handleSubmit(this.props.sendCode)} className="pvc-form">
                            {this.props.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' /> }
                            {error && <CustomAlert bsStyle="danger" message={error}/>}
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <Field className="form-control" name="sms_code" autoComplete="off" component={RenderField} type="number" label="Ingresá el código del SMS" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Siguiente</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </Section>
        );
    }
}

SmsForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

SmsForm = TopScrolleable(SmsForm);

SmsForm = reduxForm({
    form: 'SmsForm', // a unique name for this form
})(SmsForm);

SmsForm = withAuthControl(SmsForm);

export default SmsForm;



/** WEBPACK FOOTER **
 ** ./src/components/SmsForm.js
 **/